import Timeline from './Timeline';
import TimelineItem from './TimelineItem';

export {
  Timeline,
  TimelineItem,
};



// WEBPACK FOOTER //
// ./src/components/timeline/index.js